import styled, { css } from 'styled-components';
import { TextProps } from '../style.types';

export const H5_TITLE = styled.h5<TextProps>`
    ${props =>
        css`
            ${props.alignSelf && `align-self: ${props.alignSelf}`};
            background: ${props.background === 'primary'
                ? props.theme.primary
                : props.background === 'secondary'
                ? props.theme.secondary
                : props.background
                ? props.background
                : 'none'};
            ${props.border && `border: ${props.border}`};
            ${props.borderBottom && `border-bottom: ${props.borderBottom}`};
            ${props.borderBottomLeftRadius === 'default'
                ? `border-bottom-left-radius: 1rem`
                : props.borderBottomLeftRadius === 'small'
                ? `border-bottom-left-radius: 5px`
                : props.borderBottomLeftRadius === 'medium'
                ? `border-bottom-left-radius: 10px`
                : props.borderBottomLeftRadius === 'large'
                ? `border-bottom-left-radius: 2rem`
                : props.borderBottomLeftRadius === 'round'
                ? '50%'
                : props.borderBottomLeftRadius &&
                  `border-bottom-left-radius: ${props.borderBottomLeftRadius}`};
            ${props.borderBottomRightRadius === 'default'
                ? `border-bottom-right-radius: 1rem`
                : props.borderBottomRightRadius === 'small'
                ? `border-bottom-right-radius: 5px`
                : props.borderBottomRightRadius === 'medium'
                ? `border-bottom-right-radius: 10px`
                : props.borderBottomRightRadius === 'large'
                ? `border-bottom-right-radius: 2rem`
                : props.borderBottomRightRadius === 'round'
                ? '50%'
                : props.borderBottomRightRadius &&
                  `border-bottom-Right-radius: ${props.borderBottomRightRadius}`};
            ${props.borderLeft && `border-left: ${props.borderLeft}`};
            ${props.borderRadius === 'default'
                ? `border-radius: 1rem`
                : props.borderRadius === 'small'
                ? `border-radius: 5px`
                : props.borderRadius === 'medium'
                ? `border-radius: 10px`
                : props.borderRadius === 'large'
                ? `border-radius: 2rem`
                : props.borderRadius === 'round'
                ? '50%'
                : props.borderRadius && `border-radius: ${props.borderRadius}`};
            ${props.borderRight && `border-right: ${props.borderRight}`};
            ${props.borderTop && `border-top: ${props.borderTop}`};
            ${props.borderTopLeftRadius === 'default'
                ? `border-top-left-radius: 1rem`
                : props.borderTopLeftRadius === 'small'
                ? `border-top-left-radius: 5px`
                : props.borderTopLeftRadius === 'medium'
                ? `border-top-left-radius: 10px`
                : props.borderTopLeftRadius === 'large'
                ? `border-top-left-radius: 2rem`
                : props.borderTopLeftRadius === 'round'
                ? '50%'
                : props.borderTopLeftRadius &&
                  `border-top-left-radius: ${props.borderTopLeftRadius}`};
            ${props.borderTopRightRadius === 'default'
                ? `border-top-right-radius: 1rem`
                : props.borderTopRightRadius === 'small'
                ? `border-top-right-radius: 5px`
                : props.borderTopRightRadius === 'medium'
                ? `border-top-right-radius: 10px`
                : props.borderTopRightRadius === 'large'
                ? `border-top-right-radius: 2rem`
                : props.borderTopRightRadius === 'round'
                ? '50%'
                : props.borderTopRightRadius &&
                  `border-top-right-radius: ${props.borderTopRightRadius}`};
            ${props.bottom && `bottom: ${props.bottom}`};
            color: ${props.color === 'primary'
                ? props.theme.primary
                : props.color === 'secondary'
                ? props.theme.secondary
                : props.color
                ? props.color
                : 'inherit'};
            ${props.cursor && `cursor: ${props.cursor}`};
            ${props.flexBasis && `flex-basis: ${props.flexBasis}`};
            ${props.fontFamily && `font-family: ${props.fontFamily}`};
            font-size: ${props.size === 'large'
                ? 'clamp(2rem, 5vw, 4rem)'
                : props.size === 'medium'
                ? 'clamp(1.5rem, 3vw, 2.8rem)'
                : props.size === 'small'
                ? 'clamp(1.2rem, 2vw, 2rem)'
                : props.size === 'extra-small'
                ? 'clamp(1rem, 1.05rem, 1.1rem)'
                : props.size
                ? props.size
                : 'clamp(1.1rem, 1.5vw, 1.4rem)'} !important;
            ${props.fontWeight && `font-weight: ${props.fontWeight}`};
            ${props.fullWidth && 'width: 100%'};
            ${props.height && `height: ${props.height}`};
            ${props.left && `left: ${props.left}`};
            ${props.lineHeight && `line-height: ${props.lineHeight}`};
            ${props.margin && `margin: ${props.margin}`};
            ${props.marginBottom && `margin-bottom: ${props.marginBottom}`};
            ${props.marginLeft && `margin-left: ${props.marginLeft}`};
            ${props.marginRight && `margin-right: ${props.marginRight}`};
            ${props.marginTop && `margin-top: ${props.marginTop}`};
            ${props.maxWidth && `max-width: ${props.maxWidth}`};
            ${props.minWidth && `min-width: ${props.minWidth}`};
            ${props.padding && `padding: ${props.padding}`};
            ${props.paddingBottom && `padding-bottom: ${props.paddingBottom}`};
            ${props.paddingLeft && `padding-left: ${props.paddingLeft}`};
            ${props.paddingRight && `padding-right: ${props.paddingRight}`};
            ${props.paddingTop && `padding-top: ${props.paddingTop}`};
            position: ${props.position ? props.position : 'relative'};
            ${props.right && `right: ${props.right}`};
            ${props.textAlign && `text-align: ${props.textAlign}`};
            ${props.textDecoration && `text-decoration: ${props.textDecoration}`};
            ${props.textTransform && `text-transform: ${props.textTransform}`};
            ${props.top && `top: ${props.top}`};
            ${props.whiteSpace && `white-space: ${props.whiteSpace}`};
            ${props.width && `width: ${props.width}`};
            ${props.wordBreak && `word-break: ${props.wordBreak}`};
            z-index: ${props.zIndex ? props.zIndex : 0};
        `}
`;
